<template>
    <div class="survey-note-form-trend-charts">

        <div class="d-flex flex-column">
            <div cols="12" md="3">
                <b-form-radio-group button-variant="primary" buttons
                                    :stacked="$mq == 'sm'"
                                    v-model="selectedGroupIndex"
                                    :options="tabOptions">
                </b-form-radio-group>
            </div>
            <div class="badge-buttons">
                <b-row cols="1" :cols-md="currentGroup.cols">
                    <div class="col-md-6"
                         v-for="(scoreName, index) in currentGroup.trendCharts" :key="index">
                        <score-trend-widget :widget-key="scoreName"
                                            :is-indicator-light="currentGroup.isIndicatorLights">
                        </score-trend-widget>
                    </div>
                </b-row>
            </div>
        </div>

    </div>
</template>

<script>
import * as _ from 'lodash'

export default {
    name: 'SurveyNoteFormTrendCharts',
    props: {
        scoreGroups: Array
    },
    data() {
        return {
            selectedGroupIndex: 0
        }
    },
    computed: {
        tabOptions() {
            return _.map(this.scoreGroups, (group, i) => {
                return {value: i, text: group.title}
            })
        },
        currentGroup() {
            return this.scoreGroups[this.selectedGroupIndex]
        }
    }
}
</script>

<style lang="scss">
.survey-note-form-trend-charts {
    // see styles in SurveyNoteForm - SurveyNoteFormCoachingSummary uses the same styles
}
</style>
